import styled from '@emotion/styled';
import { ChevronRight } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';

const Header = styled('h2')`
  display: flex;
  align-items: center;

  > * {
    margin-right: ${(p) => p.theme.spacing()}px;
  }
`;

export const OrgNavHeader = ({ parts }: { parts: React.ReactNode[] }) => {
  return (
    <Header>
      <Link to="/orgs">Orgs</Link>
      {parts.map((p, i) => (
        <React.Fragment key={i}>
          <ChevronRight />
          <div>{p}</div>
        </React.Fragment>
      ))}
    </Header>
  );
};
